module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('headerTop'), _vm._v(" "), _c('div', {
    staticClass: "swiperImg",
    style: ({
      backgroundImage: 'url(' + _vm.$index.addurl(_vm.img) + ')'
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "center page-content flexbetween",
    style: ({
      animation: _vm.animation
    })
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "leftD"
  }, _vm._l((_vm.serList), function(item, index) {
    return _c('div', {
      staticClass: "leftD_child",
      on: {
        "click": function($event) {
          return _vm.todetail(item.id)
        }
      }
    }, [_vm._v(_vm._s(item.name))])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', {
    staticClass: "list flexleft"
  }, _vm._l((_vm.zdList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "headerChild"
    }, [_c('div', {
      staticClass: "topImg"
    }, [_c('img', {
      attrs: {
        "src": _vm.$index.addurl(item.image),
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "bottomContent"
    }, [_c('div', {
      staticClass: "botTitle"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      staticClass: "botTxt"
    }, [_vm._v(_vm._s(item.intro))]), _vm._v(" "), _c('div', {
      staticClass: "more",
      on: {
        "click": function($event) {
          return _vm.todetails(item)
        }
      }
    }, [_vm._v("了解详情")])])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "botList"
  }, _vm._l((_vm.List), function(items, indexs) {
    return _c('div', {
      key: indexs,
      staticClass: "botchild flexleft",
      on: {
        "click": function($event) {
          return _vm.todetails(items)
        }
      }
    }, [_vm._m(0, true), _vm._v(" "), _c('div', {
      staticClass: "bottitle flexbetween"
    }, [_c('div', {
      staticClass: "titles"
    }, [_vm._v(_vm._s(items.title))]), _vm._v(" "), _c('div', {
      staticClass: "time"
    }, [_vm._v(_vm._s(items.updatetime))])])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "page"
  }, [_c('el-pagination', {
    attrs: {
      "hide-on-single-page": true,
      "current-page": _vm.currentPage,
      "page-size": 20,
      "layout": "prev, pager, next",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.addPage
    }
  })], 1)])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "parentLittle"
  }, [_c('div', {
    staticClass: "little"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-aa7373b0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/square/square.vue
// module id = 1110
// module chunks = 1